import { render, staticRenderFns } from "./courrier.vue?vue&type=template&id=64937a9f&scoped=true"
import script from "./courrier.vue?vue&type=script&lang=js"
export * from "./courrier.vue?vue&type=script&lang=js"
import style0 from "./courrier.vue?vue&type=style&index=0&id=64937a9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64937a9f",
  null
  
)

export default component.exports